import React, { Component } from 'react';

import analyticService from '../../../services/analytics';
import { getClass } from '../../../utils/component-helpers';

import RowsDropdown from '../dropdowns/rows-dropdown';

import './pagination.scss';

class Pagination extends Component {
  constructor(props) {
    super(props);

    this.AnalyticService = analyticService;

    this.state = {
      pages: [], // Page labels, 1-indexed
      totalPages: 0,
    };
  }

  componentDidMount() {
    this.initializePages();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.totalItems !== this.props.totalItems ||
      prevProps.perPage !== this.props.perPage
    ) {
      this.initializePages();
    }
  }

  initializePages() {
    const totalPages = Math.ceil(this.props.totalItems / this.props.perPage);
    const pages = [];

    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }

    this.setState({ pages, totalPages });
  }

  /* Actions */
  changeNumRows(numRow) {
    if (this.props.perPage === numRow) return;

    this.AnalyticService.trackEvent(this.props.eventPrefix, 'Execute', `Show Rows ${numRow}`);
    this.props.updatePerPage(numRow);
    this.props.updatePage(1);
  }

  incrementPage(direction) {
    const gaDirection = direction === 'next' ? 'Next' : 'Previous';
    this.AnalyticService.trackEvent(this.props.eventPrefix, 'Click', `Page ${gaDirection}`);

    if (
      (direction === 'next' && this.props.currentPage < this.state.totalPages) ||
      (direction === 'prev' && this.props.currentPage > 1)
    ) {
      const value = direction === 'next' ? 1 : -1;
      const newPage = this.props.currentPage + value;
      this.props.updatePage(newPage);
    }
  }

  onPageClick(page) {
    this.AnalyticService.trackEvent(this.props.eventPrefix, 'Click', `Page ${page}`);
    this.props.updatePage(page);
  }

  /* Helper functions */
  disableArrow(direction) {
    const { currentPage } = this.props;
    return (
      (direction === 'prev' && currentPage === 1) ||
      (direction === 'next' && currentPage === this.state.totalPages)
    );
  }

  isVisible(page) {
    const { currentPage } = this.props;
    const { totalPages } = this.state;

    /*
     * Show first three pages if current page is 1,
     * last three pages if current page is the last page.
     *
     * Show page if it is the first, last, or current page,
     * the previous & next to the current page, or last three pages
     * when the current page is the last or second to last page
     */
    if (
      page === 1 ||
      page === totalPages ||
      page === currentPage ||
      page === currentPage + 1 ||
      page === currentPage - 1 ||
      (page === 3 && currentPage === 1) ||
      (page === totalPages - 2 && currentPage === totalPages)
    ) {
      return true;
    }
    return false;
  }

  showEllipses(page) {
    const { totalPages } = this.state;
    const { currentPage } = this.props;

    // Never show ellipses for the first and last page
    if (page === 1 || page === totalPages) return false;

    /*
     * Show ellipses between the previous page shown and anything before it
     * and between the next page and anything after until the last page.
     */
    if (
      (page === currentPage + 3 && page !== totalPages) ||
      (page === currentPage - 3 && page !== totalPages) ||
      (page === totalPages - 1 && currentPage === totalPages - 3) ||
      (page === 2 && currentPage === 4)
    ) {
      return true;
    }
    return false;
  }

  trackRowsOpen() {
    this.AnalyticService.trackEvent(this.props.eventPrefix, 'Click', 'Show Rows');
  }

  render() {
    if (!this.props.showPagination) return null;

    const pages = this.state.pages.map(page => {
      return (
        <li
          key={page}
          onClick={() => this.onPageClick(page)}
          className={getClass({
            current: page === this.props.currentPage,
            'visible-label': this.isVisible(page),
            ellipsis: this.showEllipses(page),
          })}
        >
          {this.showEllipses(page) ? <span className="ellipses">...</span> : null}
          <span className="page">{page}</span>
        </li>
      );
    });

    // Small hack since we cannot disable eslint line length check in jsx
    const arrowLeftSvgData =
      'M 0,50.000003 50,3.04e-6 52.281548,2.2815509 ' +
      '4.563096,50.000003 51.958184,97.39509 49.353273,100 Z';
    const arrowRightSvgData =
      'M 52.281548,50.000003 2.281548,3.04e-6 0,2.2815509 ' +
      '47.718452,50.000003 0.323364,97.39509 2.928275,100 Z';

    return (
      <div className="base-megatable pagination">
        {this.props.updatePerPage ? (
          <RowsDropdown
            perPage={this.props.perPage}
            changeNumRows={numRow => this.changeNumRows(numRow)}
            trackOpenEvent={this.trackRowsOpen.bind(this)}
            reducedPagination={this.props.reducedPagination}
          ></RowsDropdown>
        ) : (
          <span>{this.props.perPage} per page</span>
        )}

        <div className="custom-pagination">
          <label>Page</label>
          {pages}
          <div className="arrow-container">
            <div
              className={getClass('arrow previous', {
                disabled: this.disableArrow('prev'),
              })}
              onClick={() => this.incrementPage('prev')}
            >
              <svg viewBox="0 0 52 100">
                <path d={arrowLeftSvgData} />
              </svg>
            </div>
            <div
              className={getClass('arrow next', {
                disabled: this.disableArrow('next'),
              })}
              onClick={() => this.incrementPage('next')}
            >
              <svg viewBox="0 0 52 100">
                <path d={arrowRightSvgData} />
              </svg>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Pagination;
